import styled from 'styled-components';
import { Flex } from '@finect/tabular-core/Flex';

export const AnswerBlock = styled.div`
  display: inline-block;

  /* stylelint-disable */
  @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {
    width: 80%;
  }
  /* stylelint-enable */
`;

export const Answer = styled.div`
  position: relative;
  z-index: 1;
  right: -12px;
  max-width: 95%;
  padding: 18px 24px;
  border-radius: ${({ theme }) => theme.borderRadius};
  box-shadow: ${({ theme }) => theme.boxShadow};
  margin: -33px 0 0 auto;
  background-color: #fff;
  color: ${({ theme }) => theme.colors.font};

  span img,
  span svg {
    border-radius: 66px;
  }
`;

export const AnsweredBy = styled(Answer.withComponent(Flex))`
  max-width: none;
  padding: ${({ preview }) => (preview ? '6px 12px 6px 6px' : '6px 24px 6px 6px')};
  border-radius: ${({ theme }) => `66px ${theme.borderRadius} ${theme.borderRadius} 66px`};
  margin-top: ${({ preview }) => (preview ? '-18px' : '-33px')};
`;
